import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiResponse } from "../../types/apiTypes";

export const s3Api = createApi({
  reducerPath: "s3Api",
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    uploadFileToS3: builder.mutation<ApiResponse<any>, { uploadLink: string; file: any }>({
      query: ({ uploadLink, file }) => ({
        url: uploadLink,
        method: "PUT",
        body: file,
      }),
    }),
    getFile: builder.query<File, { fileUrl: string }>({
      query: ({ fileUrl }) => ({
        url: fileUrl,
        method: "GET",
        responseHandler: (response) => {
          return response.blob().then((blob) => {
            const file = new File([blob], "file", { type: blob.type });
            return file;
          });
        },
      }),
    }),
  }),
});

export const { useUploadFileToS3Mutation, useGetFileQuery, useLazyGetFileQuery } = s3Api;
